import { ICellRendererParams } from 'ag-grid-community';
import { Component, inject } from '@angular/core';

import { OrdersApiClientService } from '../../services/orders.api.client.service';
import { SharingService } from '../../sharing/services/sharing.service';

@Component({
  selector: 'app-trademark-renderer',
  templateUrl: './trademark-renderer.component.html',
  styleUrls: ['./trademark-renderer.component.scss'],
  standalone: false,
})
export class TrademarkRendererComponent {
  private ordersApiClientService = inject(OrdersApiClientService);
  private sharingService = inject(SharingService);

  trademark!: string;
  params!: ICellRendererParams;
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.trademark = params.value;
  }

  get cancelDate(): string {
    return this.params.data.cancelDate;
  }

  get orderId(): string {
    return this.params.data.id;
  }

  get activeTab(): string {
    return this.ordersApiClientService.getActiveTab();
  }

  // Temporary hiding full text lookup tab as part of TCM-121207.
  get linkedFullTextCount(): number {
    return 0;
    // return this.params.data.fullTextDetails?.length;
  }

  get isSharingEnabled(): boolean {
    return this.sharingService.isSharingFeatureEnabledForCurrentMember();
  }
}
